module.exports = __webpack_public_path__ + "static/img/vip_lock.c370a518.png";